import { z } from 'zod'

export const setNotesAsReadSchema = z.object({
  presentationId: z.string().uuid(),
  noteIds: z.array(z.string().uuid()),
})

export type SetNotesAsRead = z.infer<typeof setNotesAsReadSchema>
